export default "__VITE_ASSET__DYQSS7CG__"